import axios from "axios";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/Consultas';

export default class ConsultasService {
    async DescargarArchivo(ruta: string) {
        try {
            const response = await axios.get(localBack + APICATALOGO + '/DescargarArchivo', {
                params: { url: ruta },
                responseType: 'blob',
            });

            // response.data ya es un Blob, no hay que envolverlo en otro Blob
            const urlDescarga = window.URL.createObjectURL(response.data);
            const enlace = document.createElement('a');
            enlace.href = urlDescarga;

            // Extraer nombre del archivo de la URL o usar uno por defecto
            const nombreArchivo = ruta.split('/').pop() || 'archivo.pdf';
            enlace.download = nombreArchivo;

            document.body.appendChild(enlace);
            enlace.click();

            enlace.remove();
            window.URL.revokeObjectURL(urlDescarga);
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
        }
    }
}